// extracted by mini-css-extract-plugin
module.exports = {"MWButton":"MWButton_MWButton__19utc","MWButtonHilight":"MWButton_MWButtonHilight__1beCw"};